import { render, staticRenderFns } from "./tasting_dashboard.vue?vue&type=template&id=864d0ab8&scoped=true"
import script from "./tasting_dashboard.vue?vue&type=script&lang=js"
export * from "./tasting_dashboard.vue?vue&type=script&lang=js"
import style0 from "./tasting_dashboard.vue?vue&type=style&index=0&id=864d0ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864d0ab8",
  null
  
)

export default component.exports